import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


@Component({templateUrl: './mbenz-paylayout.component.html'})
export class MbenzPaylayoutComponent {

  constructor(
    private router: Router,

) {

}

}
